import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentMethod } from '../../models/types';
import Field from '../../components/Field';
import Button, { BUTTON_POSITION, BUTTON_TYPE, TOGGLE_TYPE } from '../../components/Button';
import Price, { CURRENCY } from '../../components/Price';
import { testPayToPhone } from '../../utils/events';
import { env } from '../../utils/util';

const TBANK_TERMINAL_ID = env('REACT_APP_TBANK_TERMINAL_ID');
const TBANK_PASSWORD = env('REACT_APP_TBANK_PASSWORD');
const TBANK_PUBLIC_KEY = env('REACT_APP_TBANK_PUBLIC_KEY');
const YOUKASSA_SHOP_ID = env('REACT_APP_YOUKASSA_SHOP_ID');
const YOUKASSA_KEY = env('REACT_APP_YOUKASSA_KEY');
const YOUKASSA_MOBILE_KEY = env('REACT_APP_YOUKASSA_MOBILE_KEY');

const paymentParams = {
  tBankTerminalId: TBANK_TERMINAL_ID,
  tBankPassword: TBANK_PASSWORD,
  tBankToken: TBANK_PUBLIC_KEY,
  yookassaShopId: YOUKASSA_SHOP_ID,
  yookassaToken: YOUKASSA_KEY,
  yookassaMobileToken: YOUKASSA_MOBILE_KEY,
};

const TestPayment = () => {
  const {t} = useTranslation(['common', 'order']);

  const [paymentMethod, setPaymentMethod] = useState(PaymentMethod.CASH);
  const [paymentComment, setPaymentComment] = useState('');
  const [paymentAmount, setPaymentAmount] = useState(0);

  const handlePayment = async () => {
    alert(paymentMethod + ' ' + paymentAmount);
    if (paymentMethod === PaymentMethod.CASH) {
    } else if (paymentMethod === PaymentMethod.CARD) {
      testPayToPhone(paymentAmount, PaymentMethod.CARD, paymentParams);
    } else if (paymentMethod === PaymentMethod.ONLINE) {
      testPayToPhone(paymentAmount, PaymentMethod.ONLINE, paymentParams);
    } else if (paymentMethod === PaymentMethod.QRCODE) {
      testPayToPhone(paymentAmount, PaymentMethod.QRCODE, paymentParams);
    }
  };

  const onChange = (v) => {
    setPaymentMethod(v);
  };

  return (
    <div className="trip-app">
      <div className={`trip-app-header`}>
        {t('common:navbar.ui_demo')}
      </div>
      <div className="trip-app-body">
        <Field title={t('order:payment_booking.payment_method')}>
          <Button.ToggleGroup type={TOGGLE_TYPE.RADIO} name={'btn-rad-2'} value={paymentMethod} onChange={onChange}>
            <Button.Toggle id={`payment_${t(`order:payment_booking.${PaymentMethod.CASH}`)}`} variant={BUTTON_TYPE.SECONDARY} value={PaymentMethod.CASH}>{t(`order:payment_booking.${PaymentMethod.CASH}`)}</Button.Toggle>
            <Button.Toggle id={`payment_${t(`order:payment_booking.${PaymentMethod.ONLINE}`)}`} variant={BUTTON_TYPE.SECONDARY} value={PaymentMethod.ONLINE}>{t(`order:payment_booking.${PaymentMethod.ONLINE}`)}</Button.Toggle>
            <Button.Toggle id={`payment_${t(`order:payment_booking.${PaymentMethod.QRCODE}`)}`} variant={BUTTON_TYPE.SECONDARY} value={PaymentMethod.QRCODE}>{t(`order:payment_booking.${PaymentMethod.QRCODE}`)}</Button.Toggle>
            <Button.Toggle id={`payment_${t(`order:payment_booking.${PaymentMethod.CARD}`)}`} variant={BUTTON_TYPE.SECONDARY} value={PaymentMethod.CARD}>{t(`order:payment_booking.${PaymentMethod.CARD}`)}</Button.Toggle>
          </Button.ToggleGroup>
        </Field>

        <Field title={t('order:payment_booking.comment')}>
          <textarea rows="3" onChange={(e) => setPaymentComment(e.target.value)} value={paymentComment}/>
        </Field>

        <Field title={t('order:payment.total_amount')}>
          <Price.Input currency={CURRENCY.RUB} value={paymentAmount} onChange={setPaymentAmount}/>
        </Field>

        <Button.Panel>
          <Button position={BUTTON_POSITION.LEFT} variant={BUTTON_TYPE.PRIMARY} onClick={handlePayment}>{t('common:button.pay')}</Button>
        </Button.Panel>
      </div>
    </div>
  )
}

export default TestPayment;